import { render } from "./Window.vue?vue&type=template&id=688fc339&scoped=true"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"

import "./Window.vue?vue&type=style&index=0&id=688fc339&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688fc339"]])

export default __exports__